<template>
  <button
    v-if="isCompactView"
    class="px-2 py-2 block z-20 bg-[var(--nav-back-button-bg)] text-center relative w-full text-sm font-bold lg:hidden"
    tabindex="-1"
    role="menuitem"
    @click.prevent="focusParentTier"
  >
    <pdl-icon
      class="absolute left-4 top-0 bottom-0 my-auto"
      style="color: var(--nav-back-arrow-color)"
      name="chevron_left"
    />
    <span class="flex justify-center items-center" v-html="label" />
  </button>
</template>
<script>
import {PdlIcon} from '@pedal/pdl-icon';
import {mapState} from 'vuex';
export default {
  name: 'NavBackButton',
  components: {
    PdlIcon,
  },
  inject: ['focusParentTier'],
  props: {
    label: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapState('global', ['isCompactView']),
  },
};
</script>
